import React, { Component } from 'react'
import { translate } from '../../utils/useful'
import FixedView from '../../components/FixedView'
import IntractionActionsList from '../../components/IntractionActionsList'
import importedIcons from '../../components/inputs/icons'
import StagesManager from '../../components/StagesManager'

export default class DriveOptions extends Component {

    closeFixedView = () => {
        this.optionsView.hideView()
    }

    render() {
        return (
            <>
                <button className='mrd-2 flexcc dark-blur-hover px-2 py-1 br-5' ref={el => this.options = el} onClick={() => { this.optionsView.showView() }}>
                    <p className='white font-size-13' style={{ color: this.props.colors?.textColor }}>{translate('drives.Options')}</p>
                </button>
                <FixedView width={this.props.width} zIndex={10} ref={el => this.optionsView = el} nodeRef={this.options} xOffset={this.props.language == 'fa' ? 185 : -10} bottomOffset={0} topOffset={0} maxWidth={260} >
                    <div className='bg-white br-10 p-1 shadow-3'>
                        <div className=' p-1 sc-gray2' style={{ maxHeight: '350px', overflowY: 'auto', }}>
                            <div className=''>
                                <div className='mb-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Undo", icon: importedIcons.undo }} />
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Pin to Quick access", icon: importedIcons.pin }} />
                                </div>
                                <div className='py-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Select all", icon: importedIcons.selectAll }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Select none", icon: importedIcons.selectNone }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Invert Selection", icon: importedIcons.invertSelect }} />
                                </div>
                                <div className='pt-2' style={{ borderTop: "1px solid #eee" }}>
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Properties", icon: importedIcons.properties }} />
                                    <IntractionActionsList data={{ title: "{{lang}}drives.Options", icon: importedIcons.setting }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </FixedView>
            </>
        )
    }
}
